<script setup lang="ts">
/** Discords Datums-Trenner: Hairline mit zentriertem Datum. */
defineProps<{ label: string }>()
</script>

<template>
  <div class="dc-divider" role="separator" :aria-label="label">
    <span class="dc-divider-label">{{ label }}</span>
  </div>
</template>

<style scoped>
.dc-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px 4px;
  font-family: var(--font-discord);
}

.dc-divider::before,
.dc-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--dc-hairline);
}

.dc-divider-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--dc-ink-muted);
  white-space: nowrap;
}
</style>
